import { Injectable } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormGroup,
  Validators,
} from "@angular/forms";
import { createAmountAbove30KValidator, createSumInsuredValidator, createTZLimitsValidator } from "../validators/custom.validators";

@Injectable({
  providedIn: "root",
})
export class ValidationService {
  constructor() {}
  logValidationErrors(
    group: FormGroup,
    formErrors: { [key: string]: string },
    validationMessages: { [key: string]: { [key: string]: string } },
    allowValidationFormArray=true
  ): { [key: string]: string } {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.controls[key];
      formErrors[key] = "";
      if (
        abstractControl &&
        !abstractControl.valid &&
        this.isControlVisible(abstractControl) &&
        (abstractControl.touched || abstractControl.dirty)
      ) {
        const messages = validationMessages[key];
        for (const keyError in abstractControl.errors) {
          if (keyError) {
            if (keyError !== "matDatepickerParse")
              formErrors[key] += `${messages[keyError]} `;
            else formErrors[key] += `${messages["required"]} `;
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(
          abstractControl,
          formErrors,
          validationMessages
        );
      }

      if (abstractControl instanceof FormArray && allowValidationFormArray) {
        for (const control of abstractControl.controls) {
          if (control instanceof FormGroup) {
            this.logValidationErrors(control, formErrors, validationMessages);
          }
        }
      }
    });
    return formErrors;
  }

  isControlVisible(control: AbstractControl): boolean {
    // This log helps debug the validity of the form and its controls
    // console.log('::::::::::::::::::::::::::::: FORM + CONTROLS DEBUG', control.parent);
    let parent = control.parent;
    while (parent) {
      if (parent.disabled) {
        return false;
      }
      parent = parent.parent;
    }
    return true;
  }
  
  addOrRemoveValidator(delimitor: Boolean, control: AbstractControl) {
    if (delimitor) control?.setValidators(Validators.required);
    else {
      control?.clearValidators();
      control?.updateValueAndValidity();
    }
  }
  addOrRemoveValidatorSMinReq(delimitor: Boolean, control: AbstractControl, minAmount : number) {
    if (delimitor) control?.setValidators([Validators.required, Validators.min(minAmount)]);
    else {
      control?.clearValidators();
      control?.updateValueAndValidity();
    }
  }
  addOrRemoveSeatingCommercialValidator(delimitor: Boolean, control: AbstractControl) {
    if (delimitor) control?.setValidators([Validators.required, Validators.min(1), Validators.max(69)]);
    else {
      control?.clearValidators();
      control?.updateValueAndValidity();
    }
  }
  addOrRemoveCurrenciedValidator(delimitor: Boolean, control: AbstractControl) {
    if (delimitor) control?.setValidators([Validators.required, createAmountAbove30KValidator()]);
    else {
      control?.clearValidators();
      control?.updateValueAndValidity();
    }
  }

  addSumInsuredValidator(delimitor: Boolean, control: AbstractControl, isMotorcycle : Boolean) {
    if (delimitor) control?.setValidators([Validators.required, createSumInsuredValidator(isMotorcycle)]);
    else {
      control?.clearValidators();
      control?.updateValueAndValidity();
    }
  }

  addTZCurrenciedValidator(delimitor: Boolean, control: AbstractControl, type: string) {
    if (delimitor) control?.setValidators([Validators.required, createTZLimitsValidator(type)]);
    else {
      control?.clearValidators();
      control?.updateValueAndValidity();
    }
  }

  addOrRemoveIDumValidator(delimitor: Boolean, control: AbstractControl, min: number, max: number) {
    if (delimitor) {
      control?.setValidators([Validators.required, Validators.maxLength(max), Validators.minLength(min)]);
    }
    else {
      control?.clearValidators();
      control?.updateValueAndValidity();
    }
  }
  subcribeToControlChanges(
    control: AbstractControl | string,
    controlGroup: FormGroup,
    formGroupErrors: { [key: string]: string },
    validationMessages: { [key: string]: { [key: string]: string } },
    otherControl?: AbstractControl
  ) {
    if (!(control instanceof AbstractControl)) {
      const group = controlGroup.get(control);
      group?.valueChanges.subscribe((value) => {
        let isTrue = false;
        Object.keys(value).forEach((key) => {
          if (value[key]) isTrue = true;
        });

        this.addOrRemoveValidityOnFormGroup(
          isTrue!,
          control,
          controlGroup,
          formGroupErrors,
          validationMessages
        );
      });
    } else {
      if (otherControl) this.addOrRemoveValidator(true, otherControl);
      else this.addOrRemoveValidator(true, control);
    }
  }
  addOrRemoveValidityOnFormGroup(
    delimiter: Boolean,
    group: string,
    controlGroup: FormGroup,
    formGroupErrors: { [key: string]: string },
    validationMessages: { [key: string]: { [key: string]: string } }
  ) {
    const groupControl = controlGroup.get(group)!;
    groupControl.setErrors(null);
    formGroupErrors[group] = "";
    if (!delimiter) {
      formGroupErrors[group] = validationMessages[group]["required"];
      groupControl.setErrors({ invalid: true });
    }
  }
  addOrRemoveValidationDependent(
    initControl: AbstractControl,
    effectControl: string,
    groupControl:FormGroup,
    formGroupErrors:{[key:string]:string},
    validationMessages:{[key:string]:{[key:string]:string}},
  ) {
    initControl?.valueChanges.subscribe((data: Boolean) => {
      const control = groupControl.get(effectControl)!;
      if (control instanceof FormGroup)
        this.addOrRemoveValidityOnFormGroup(
          data,
          effectControl,
          groupControl,
          formGroupErrors,
          validationMessages
        );
      else this.addOrRemoveValidator(data, control);
    });
  }

  addOrRemoveValidationDependentGarageOnly(
    initControl: AbstractControl,
    effectControl: string,
    groupControl:FormGroup,
    checkerString: string,
  ) {
    initControl?.valueChanges.subscribe((data: string) => {
      const control = groupControl.get(effectControl)!;
      if (data === checkerString)
        this.addOrRemoveValidator(true, control);
      else
        this.addOrRemoveValidator(false, control);
    });
  }
}
